import "./App.css";
import NavBar from "./navbar/NavBar";
import Home from "./home/Home";
import MenuPage from "./menu/MenuPage";
import About from "./about/About";
import Footer from "./footer/Footer";

import {
  Routes,
  Route,
  useParams,
  useNavigate,
  Navigate,
} from "react-router-dom";

function getId(window, desktopId, mobileId) {
  return window.innerWidth < 800 || window.innerHeight < 600
    ? mobileId
    : desktopId;
}

function getMedia(id, rep, setId) {
  const url = process.env.REACT_APP_CONNECTION_STRING;
  fetch(`${url}/${rep}/${id}`, { mode: "cors" }).then((response) => {
    response.json().then((b) => {
      localStorage.setItem(id, b.url);
      setId(`${url}${b.url}`);
    });
  });
}

function MainPage({ lang }) {
  return (
    <div className="bg">
      <div id="content">
        {/* Language Selector */}
        <div style={{ textAlign: "right", margin: "10px" }}>
          <LanguageSelector lang={lang} />
        </div>
        <NavBar lang={lang} />
        <section className="ui home" id="home">
          <Home lang={lang} />
        </section>
        <section className="ui" id="about">
          <About lang={lang} />
        </section>
        <section id="contact">
          <Footer lang={lang} />
        </section>
      </div>
    </div>
  );
}

function LanguageSelector({ lang }) {
  const navigate = useNavigate();

  const handleLanguageChange = (e) => {
    navigate(`/${e.target.value}`);
  };

  return (
    <select value={lang} onChange={handleLanguageChange}>
      <option value="en">English</option>
      <option value="pt">Português</option>
    </select>
  );
}

function LanguageWrapper() {
  const { lang } = useParams();

  return (
    <Routes>
      <Route path="menu" element={<MenuPage lang={lang} />} />
      <Route path="*" element={<MainPage lang={lang} />} />
    </Routes>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/en" replace />} />
      <Route path=":lang/*" element={<LanguageWrapper />} />
    </Routes>
  );
}

export default App;
export { getMedia, getId };
